import { render, staticRenderFns } from "./calculation.vue?vue&type=template&id=41cd674e&scoped=true&"
import script from "./calculation.vue?vue&type=script&lang=js&"
export * from "./calculation.vue?vue&type=script&lang=js&"
import style0 from "./calculation.vue?vue&type=style&index=0&id=41cd674e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd674e",
  null
  
)

export default component.exports